import { useAnalyticsActionTracker, useAnalyticsPageViewTracker } from '../../analytics';
import { HeroImage as LandingPageTeaserUi, useOidcAuthentication } from '@cp-shared-19/frontend-ui';

import { withLoadingAndNoConnectionHandler } from '../integration-wrapper';
import React from 'react';
import { useLogin } from '../../auth/useLogin';
import { useLandingPageTeaser } from './useLandingPageTeaser';
import { removeInvoiceDeliveryNotificationsForSession } from '../invoice-deliveries-notification/InvoiceDeliveryNotificationsSlice';
import { useHistory } from 'react-router-dom';
import { dashboardPagePath } from '../navigation/paths';

export const LandingPageTeaser: React.FC = () => {
    const { cmsContent: landingPageTeaser, isLoading, loadingError } = useLandingPageTeaser();
    const { isAuthenticated } = useOidcAuthentication();
    const login = useLogin();
    const { onAction } = useAnalyticsActionTracker('login');
    const history = useHistory();
    if (isAuthenticated) {
        history.push(dashboardPagePath());
    }
    useAnalyticsPageViewTracker('landingPage', !!landingPageTeaser, isAuthenticated);

    const LandingPageTeaserWithHandlers = withLoadingAndNoConnectionHandler(LandingPageTeaserUi);
    const onClick = (): void => {
        removeInvoiceDeliveryNotificationsForSession();
        onAction();
        login();
    };

    return (
        <LandingPageTeaserWithHandlers
            isLoading={isLoading}
            hasError={!!loadingError}
            title={landingPageTeaser?.title || ''}
            text={landingPageTeaser?.text || ''}
            imageUrl={landingPageTeaser?.imageUrl || ''}
            subTitle={landingPageTeaser?.subTitle}
            buttonText={landingPageTeaser?.buttonText}
            clickHandler={onClick}
            inverted={!!landingPageTeaser?.isInverted}
        />
    );
};
